import React from 'react'
import { Redirect, Route } from 'react-router-dom'

export function createRoutes(routeDefinitions, props) {
  const routes = Object.entries(routeDefinitions).map(
    ([path, routeDefinition]) => {
      const { routeComponent: RouteComponent, ...rest } = routeDefinition
      return <RouteComponent key={path} path={path} props={props} {...rest} />
    }
  )

  routes.push(
    <Route
      component={() => <Redirect to="/not-found" />}
      key="not-found-redirect"
    />
  )

  return routes
}

export default createRoutes
